import { render, staticRenderFns } from "./register-save.vue?vue&type=template&id=8fc4498a"
import script from "./register-save.vue?vue&type=script&lang=js"
export * from "./register-save.vue?vue&type=script&lang=js"
import style0 from "./register-save.vue?vue&type=style&index=0&id=8fc4498a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports